export default "__VITE_ASSET__DjC2wEne__"